import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ConstantService } from "../../../components/common/utils/constant.service";
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { BienSolicitudEntity } from "../datosGenerales/entities/bien_asegurado_entity";

@Injectable()
export class CancelacionService {
       private url="infoClienteIndividual";
      
    constructor(public authHttp: AuthHttp) { 
         let constantService = new ConstantService();  
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultaMotivos(): Observable<ListaDiccionaryEntity[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/consultaMotivosCancelacion",options).map(this.extractData)
            .catch(this.handleError);
    }

    generarCartaCancelacion(parametros: BienSolicitudEntity): Observable<any> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/generarCartaCancelacion/", body, options)
            .map(response => response).catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/cancelaciones/cancelacion.service.ts